import { useNotificationSoundState } from "@/hooks/useUnlockNotificationSound";

export function EnableSoundBanner() {
  const { enabled, enable } = useNotificationSoundState();

  if (enabled) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        background: '#111',
        color: '#fff',
        padding: '12px 16px',
        borderRadius: 8,
        zIndex: 9999,
      }}
    >
      <span style={{ marginRight: 12 }}>
        🔔 Enable notification sound
      </span>
      <button
        onClick={() => {
          enable().catch((e) => {
            console.warn('[EnableSoundBanner] Failed to enable sound', e);
          });
        }}
        style={{
          background: '#4CAF50',
          color: '#fff',
          border: 'none',
          padding: '6px 10px',
          borderRadius: 4,
          cursor: 'pointer',
        }}
      >
        Enable
      </button>
    </div>
  );
}